<template>
  <div class="container-home">
    <div class="header-box">
      <div class="header-menu">
        <p><b style="font-size:28px; font-weight: 800;">Home</b></p>
        <p style="margin-left: 25px; font-size:16px; color: #666; margin-top: 8px;">訪問者集計情報</p>
      </div>
    </div>
    <div class="menu">
      <div class="graph-tabs tabs is-toggle" v-if="isGraph||true">
        <ul>
          <li :class="{'is-active-tab': viewType === 'day'}">
            <a @click="dayGraphView()">
              <span class="graph-tab-item">日</span>
            </a>
          </li>
          <li :class="{'is-active-tab': viewType === 'oneweek'}">
            <a @click="oneWeekGraphView()">
              <span class="graph-tab-item">週</span>
            </a>
          </li>
          <li :class="{'is-active-tab': viewType === 'twoweek'}">
            <a @click="twoWeekGraphView()">
              <span class="graph-tab-item">2週</span>
            </a>
          </li>
          <li :class="{'is-active-tab': viewType === 'month'}">
            <a @click="monthGraphView()">
              <span class="graph-tab-item">月</span>
            </a>
          </li>
        </ul>
        <div class="preview -left">
          <div class="button is-rounded" @click="prevView()">
            <span class="mdi mdi-24px mdi-dark mdi-inactive mdi-chevron-left"></span>
          </div>
        </div>
        <div class="preview -right">
          <div class="button is-rounded" @click="nextView()">
            <span class="mdi mdi-24px mdi-dark mdi-inactive mdi-chevron-right"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="sum">
    </div>
    <div class="chart" v-if="isGraph">
      <b-loading
        :active="isLoading"
        :is-full-page="false">
      </b-loading>
      <line-chart :chart-data="lineDatacollection" :height="240"></line-chart>
    </div>
    <div class="pagination-wrapper">  
      <b-pagination
            :total="urlList.length"
            :current.sync="pages"
            :per-page="5"
            :size="'is-small'">
      </b-pagination>  
    </div>
    <table class="seeker-table" border="1" bordercolor="#DBDBDB">
      <tr align="center">
        <th class="default-color" align="center" width="350px">ページURL</th>
        <th @click="toggleGraphLine('dau')" class="red-th" :class="{ btnColor_red: btnFlg.dau }" align="center" valign="middle">
          <b-tooltip label="ホームページ / HRモンスター求人ページに訪れた人の合計数です。" multilined>訪問者計</b-tooltip>
        </th>
        <th @click="toggleGraphLine('new')" class="purple-th" :class="{ btnColor_purple: btnFlg.new }" align="center" valign="middle">
          <b-tooltip label="ホームページ / HRモンスター求人ページに初めて訪れた人の数です。" multilined>新規</b-tooltip>
        </th>
        <th @click="toggleGraphLine('reseeker')" class="blue-th" :class="{ btnColor_blue: btnFlg.reseeker }" align="center" valign="middle">
          <b-tooltip label="ホームページ / HRモンスター求人ページに２回目以降訪れた人の数です。" multilined>再訪問</b-tooltip>
        </th>
        <th @click="toggleGraphLine('icon')" class="green-th" :class="{ btnColor_green: btnFlg.icon }" align="center" valign="middle">
          <b-tooltip label="HRモンスターのアイコンをクリックした人の数です。" multilined>アイコン<br>クリック</b-tooltip>
        </th>
        <th @click="toggleGraphLine('alreadyRead')" class="lightgreen-th" :class="{ btnColor_lightgreen: btnFlg.alreadyRead }" align="center" valign="middle">
          <b-tooltip label="チャットの会話画面まで遷移した人の数です。" multilined>既読</b-tooltip>
        </th>
        <th @click="toggleGraphLine('reply')" class="yellow-th" :class="{ btnColor_yellow: btnFlg.reply }" align="center" valign="middle">
          <b-tooltip label="チャットの会話画面から、一回以上会話した人の数です。" multilined>返信</b-tooltip>
        </th>
        <th @click="toggleGraphLine('subscribe')" class="orange-th" :class="{ btnColor_orange: btnFlg.subscribe }" align="center" valign="middle">
          <b-tooltip label="チャットの会話画面から、HRモンスターを用いて応募した人の数です。" multilined>応募者</b-tooltip>
        </th>
        <th @click="toggleGraphLine('useragent')" class="brown-th" :class="{ btnColor_brown: btnFlg.useragent }" align="center" valign="middle">
          <b-tooltip label="ホームページ / HRモンスター求人ページに訪れた人のスマートフォンユーザー数です。" multilined>スマホ<br>ユーザー</b-tooltip>
        </th>
      </tr>
      <tr>
        <td class="sum default-color">合計</td>
        <td v-if="sumCount.dau" class="count red bold" align="right" valign="middle">{{sumCount.dau}}</td>
        <td v-else class="count red bold" align="right" valign="middle">0</td>
        <td v-if="sumCount.new" class="count purple bold" align="right" valign="middle">{{sumCount.new}}</td>
        <td v-else class="count purple bold" align="right" valign="middle">0</td>
        <td v-if="sumCount.reseeker" class="count blue bold" align="right" valign="middle">{{sumCount.reseeker}}</td>
        <td v-else class="count blue bold" align="right" valign="middle">0</td>
        <td v-if="sumCount.icon" class="count green bold" align="right" valign="middle">{{sumCount.icon}}</td>
        <td v-else class="count green bold" align="right" valign="middle">0</td>
        <td v-if="sumCount.alreadyRead" class="count lightgreen bold" align="right" valign="middle">{{sumCount.alreadyRead}}</td>
        <td v-else class="count lightgreen bold" align="right" valign="middle">0</td>
        <td v-if="sumCount.reply" class="count yellow bold" align="right" valign="middle">{{sumCount.reply}}</td>
        <td v-else class="count yellow bold" align="right" valign="middle">0</td>
        <td v-if="sumCount.subscribe" class="count orange bold" align="right" valign="middle">{{sumCount.subscribe}}</td>
        <td v-else class="count orange bold" align="right" valign="middle">0</td>
        <td v-if="sumCount.useragent" class="count brown bold" align="right" valign="middle">{{sumCount.useragent}}</td>
        <td v-else class="count brown bold" align="right" valign="middle">0</td>
      </tr>
      <tr v-for="(url, i) in displayUrl" :key="i">
        <!-- URL全表示のとき-->
        <td v-if="url !== ''" @click="urlClick(url)" class="url"><p><span class="default-color index-number">{{(pages - 1) * 5 + i + 1}}.</span>{{url}}</p></td>
        <td v-if="url !== ''" class="count" align="right" valign="middle">{{sumCount.dau == 0 ? 0 : commaSeparated(newCount(url) > reseekerCount(url) ? newCount(url) : reseekerCount(url))}}</td>
        <td v-if="url !== ''" class="count" align="right" valign="middle">{{sumCount.new == 0 ? 0 : commaSeparated(newCount(url))}}</td>
        <td v-if="url !== ''" class="count" align="right" valign="middle">{{sumCount.reseeker == 0 ? 0 : commaSeparated((reseekerCount(url) - newCount(url)) > 0 ? (reseekerCount(url) - newCount(url)) : 0)}}</td>
        <td v-if="url !== ''" class="count" align="right" valign="middle">{{sumCount.icon == 0 ? 0 : commaSeparated(iconCount(url))}}</td>
        <td v-if="url !== ''" class="count" align="right" valign="middle">{{sumCount.alreadyRead == 0 ? 0 : commaSeparated(alreadyReadCount(url))}}</td>
        <td v-if="url !== ''" class="count" align="right" valign="middle">{{sumCount.reply == 0 ? 0 : commaSeparated(replyCount(url))}}</td>
        <td v-if="url !== ''" class="count" align="right" valign="middle">{{sumCount.subscribe == 0 ? 0 : commaSeparated(subscribeCount(url))}}</td>
        <td v-if="url !== ''" class="count" align="right" valign="middle">{{sumCount.useragent == 0 ? 0 : commaSeparated(userAgentCount(url))}}</td>
        <!-- URL個別表示のとき-->
        <td v-if="url === ''" class="url"></td>
        <td v-if="url === ''" class="count" align="right" valign="middle"><p class="blank"></p></td>
        <td v-if="url === ''" class="count" align="right" valign="middle"><p class="blank"></p></td>
        <td v-if="url === ''" class="count" align="right" valign="middle"><p class="blank"></p></td>
        <td v-if="url === ''" class="count" align="right" valign="middle"><p class="blank"></p></td>
        <td v-if="url === ''" class="count" align="right" valign="middle"><p class="blank"></p></td>
        <td v-if="url === ''" class="count" align="right" valign="middle"><p class="blank"></p></td>
        <td v-if="url === ''" class="count" align="right" valign="middle"><p class="blank"></p></td>
        <td v-if="url === ''" class="count" align="right" valign="middle"><p class="blank"></p></td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LineChart from './LineChart'
import moment from 'moment'
export default {
  name: 'Home',
  componentName: 'Home',
  components: {
    LineChart
  },
  data () {
    return {
      standardDay: new Date(),
      standardDayIndex: 0,
      isGraph: true,
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: 'asc',
      currentPage: 1,
      perPage: 7,
      viewType: 'day',
      seekerCountTotal: 0,
      newCounts: 0,
      btnFlg: {
        dau: true,
        new: false,
        reseeker: false,
        icon: false,
        alreadyRead: false,
        reply: false,
        subscribe: false,
        useragent: false,
      },
      pages: 0,
      clickUrl: ''
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('directtalk', ['dashboardKPI', 'isLoading', 'graphData', 'urlList', 'displayUrl', 'barDatacollection', 'lineDatacollection', 'sumCount','isUrl']),
  },
  mounted () {
    console.debug('*** Start *** mounted')
    const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
    this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
    const con = {'is_connect': true}
    this.$store.dispatch('auth/setUserConnect', con)

    if (this.$route.query.pages) {
      if (this.$route.query.pages >= 1) {
        this.pages = Number(this.$route.query.pages)
      }
    } else {
      this.clickUrl = ''
      this.pages = 1
      this.$router.push('/dashboard?pages=1')
    }
    console.debug('*** End *** mounted')
  },
  watch: {
    '$route.query.pages' () {
      this.pages = Number(this.$route.query.pages)
      this.$router.push('/dashboard?pages=' + this.pages)
    },
    '$route.query.uri' () {
      if (this.$route.query.uri) {
        this.$router.push('/dashboard?pages=' + this.$route.query.pages + '&uri='+ this.clickUrl)
      } else {
        this.clickUrl = ''
        this.pages = Number(this.$route.query.pages)
        if (this.pages == 1) this.dayGraphView()
      }
    },
    pages () {
      if (this.pages >= 1 && !this.$route.query.uri) {
        this.clickUrl = ''
        if (this.viewType == 'day') {
          this.dayGraphView()
        } else if (this.viewType == 'oneweek') {
          this.oneWeekGraphView()
        } else if (this.viewType == 'twoweek') {
          this.twoWeekGraphView()
        } else if (this.viewType == 'month') {
          this.monthGraphView()
        }
        this.$router.push('/dashboard?pages=' + this.pages)
      }
    },
    clickUrl () {
      if (this.clickUrl !== '') {
        this.$router.push('/dashboard?' + 'pages=' +  this.pages + '&uri='+ this.clickUrl)
        // this.clickUrl = ''
      }
    },
  },
  methods: {
    changeView () {
      console.debug('*** Start *** changeView')
      this.isGraph = !this.isGraph
      console.debug('*** End *** changeView')
    },
    dayGraphView () {
      console.debug('*** Start *** startGraphView')
      this.changeLoading()
      this.viewType = 'day'
      var maxDay = moment(this.standardDay).add(0, 'days').format('YYYY-MM-DD')
      var minDay = moment(this.standardDay).add(-6, 'days').format('YYYY-MM-DD')
      var data = { maxDay: maxDay, minDay: minDay, pages: this.pages, clickUrl: this.clickUrl, type: 'day' }
      this.$store.dispatch('directtalk/getGraphData', data)
      console.debug('*** End *** startGraphView')
    },
    oneWeekGraphView () {
      console.debug('*** Start *** oneWeekGraphView')
      this.changeLoading()
      this.viewType = 'oneweek'
      var maxDay = moment(this.standardDay).set('day', -1).add(3, 'week').format('YYYY-MM-DD')
      var minDay = moment(this.standardDay).set('day', -5).add(-4, 'week').format('YYYY-MM-DD')
      var data = { maxDay: maxDay, minDay: minDay, pages: this.pages, clickUrl: this.clickUrl, type: 'week' }
      this.$store.dispatch('directtalk/getGraphData', data)
      console.debug('*** End *** oneWeekGraphView')
    },
    twoWeekGraphView () {
      console.debug('*** Start *** twoWeekGraphView')
      this.changeLoading()
      this.viewType = 'twoweek'
      var maxDay = moment(this.standardDay).set('day', -5).add(1, 'week').format('YYYY-MM-DD')
      var minDay = moment(this.standardDay).set('day', -12).add(-8, 'week').format('YYYY-MM-DD')
      var data = { maxDay: maxDay, minDay: minDay, pages: this.pages, clickUrl: this.clickUrl, type: 'biweek' }
      this.$store.dispatch('directtalk/getGraphData', data)
      console.debug('*** End *** twoWeekGraphView')
    },
    monthGraphView () {
      console.debug('*** Start *** monthGraphView')
      this.changeLoading()
      this.viewType = 'month'
      var maxDay = moment(this.standardDay).add('month', 0).endOf('month').format('YYYY-MM-DD')
      var minDay = moment(this.standardDay).add('month', -5).startOf('month').format('YYYY-MM-DD')
      var data = { maxDay: maxDay, minDay: minDay, pages: this.pages, clickUrl: this.clickUrl, type: 'month' }
      this.$store.dispatch('directtalk/getGraphData', data)
      console.debug('*** End *** monthGraphView')
    },
    prevView () {
      console.debug('*** Start *** prevView')
      if (this.isLoading === false) {
        this.changeLoading()
        var expr = this.viewType
        switch (expr) {
          case 'day':
            console.info('Selected day')
            this.standardDay = moment(this.standardDay).add(-1, 'week').format('YYYY-MM-DD')
            this.dayGraphView()
            break
          case 'oneweek':
            console.info('Selected oneweek')
            this.standardDay = moment(this.standardDay).add(-5, 'week').format('YYYY-MM-DD')
            this.oneWeekGraphView()
            break
          case 'twoweek':
            console.info('Selected twoweek')
            this.standardDay = moment(this.standardDay).add(-5, 'week').format('YYYY-MM-DD')
            this.twoWeekGraphView()
            break
          case 'month':
            console.info('Selected month')
            this.standardDay = moment(this.standardDay).add(-6, 'month').format('YYYY-MM-DD')
            this.monthGraphView()
            break
          default:
            console.info('Selected default')
        }
      }
      console.debug('*** End *** prevView')
    },
    nextView () {
      console.debug('*** Start *** nextView')
      if (this.isLoading === false) {
        this.changeLoading()
        var expr = this.viewType
        switch (expr) {
          case 'day':
            console.info('Selected day')
            this.standardDay = moment(this.standardDay).add(1, 'week').format('YYYY-MM-DD')
            this.dayGraphView()
            break
          case 'oneweek':
            console.info('Selected oneweek')
            this.standardDay = moment(this.standardDay).add(5, 'week').format('YYYY-MM-DD')
            this.oneWeekGraphView()
            break
          case 'twoweek':
            console.info('Selected twoweek')
            this.standardDay = moment(this.standardDay).add(6, 'week').format('YYYY-MM-DD')
            this.twoWeekGraphView()
            break
          case 'month':
            console.info('Selected month')
            this.standardDay = moment(this.standardDay).add(6, 'month').format('YYYY-MM-DD')
            this.monthGraphView()
            break
          default:
            console.info('Selected default')
        }
      }
      console.debug('*** End *** nextView')
    },
    changeLoading () {
      this.$store.dispatch('directtalk/openLoading')
    },
    newCount (url) {
      var count = 0
      for (var data of this.graphData) {
        for (var n of data.new) {
          if (url === n.url) {
            count ++
          }
        }
      }
      return count.toLocaleString('ja-JP')
    },
    reseekerCount (url) {
      var count = 0
      for (var data of this.graphData) {
        for (var d of data.reseeker) {
          if (url === d.url) {
            count ++
          }
        }
      }
      return count
    },
    iconCount (url) {
      var count = 0
      for (var data of this.graphData) {
        for (var d of data.icon) {
          if (url === d.url) {
            count ++
          }
        }
      }
      return count
    },
    alreadyReadCount (url) {
      var count = 0
      for (var data of this.graphData) {
        for (var d of data.already_read) {
          if (url === d.url) {
            count ++
          }
        }
      }
      return count
    },
    replyCount (url) {
      var count = 0
      for (var data of this.graphData) {
        for (var d of data.reply) {
          if (url === d.url) {
            count ++
          }
        }
      }
      return count
    },
    subscribeCount (url) {
      var count = 0
      for (var data of this.graphData) {
        for (var d of data.subscribe) {
          if (url === d.url) {
            count ++
          }
        }
      }
      return count
    },
    userAgentCount (url) {
      var count = 0
      for (var data of this.graphData) {
        for (var d of data.user_agent) {
          if (url === d.url) {
            count ++
          }
        }
      }
      return count
    },
    commaSeparated (count) {
      var arr;
      arr = String(count).split('.');
      arr[0] = arr[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      return arr.join('.')
    },
    toggleGraphLine (lineName) {
      this.$store.dispatch('directtalk/toggleGraphLine', lineName)
      if (lineName === 'dau') {
        this.btnFlg.dau = !this.btnFlg.dau
      } else if (lineName === 'new') {
        this.btnFlg.new = !this.btnFlg.new
      } else if (lineName === 'reseeker') {
        this.btnFlg.reseeker = !this.btnFlg.reseeker
      } else if (lineName === 'icon') {
        this.btnFlg.icon = !this.btnFlg.icon
      } else if (lineName === 'alreadyRead') {
        this.btnFlg.alreadyRead = !this.btnFlg.alreadyRead
      } else if (lineName === 'reply') {
        this.btnFlg.reply = !this.btnFlg.reply
      } else if (lineName === 'subscribe') {
        this.btnFlg.subscribe = !this.btnFlg.subscribe
      } else if (lineName === 'useragent') {
        this.btnFlg.useragent = !this.btnFlg.useragent
      }
    },
    urlClick (url) {
      if (this.viewType === 'day') {
        this.changeLoading()
        var maxDay = moment(this.standardDay).add(0, 'days').format('YYYY-MM-DD')
        var minDay = moment(this.standardDay).add(-6, 'days').format('YYYY-MM-DD')
        this.clickUrl = url
        var clickUrl = url
        var pages = 1
        var data = { maxDay: maxDay, minDay: minDay,  clickUrl: clickUrl, pages: pages, type: 'day' }
        this.$store.dispatch('directtalk/getGraphData', data)
      } else if (this.viewType === 'oneweek') {
        this.changeLoading()
        var maxDay = moment(this.standardDay).set('day', -1).add(3, 'week').format('YYYY-MM-DD')
        var minDay = moment(this.standardDay).set('day', -5).add(-4, 'week').format('YYYY-MM-DD')
        this.clickUrl = url
        var clickUrl = url
        var pages = 1
        var data = { maxDay: maxDay, minDay: minDay, clickUrl: clickUrl, pages: pages, type: 'week' }
        this.$store.dispatch('directtalk/getGraphData', data)
      } else if (this.viewType === 'twoweek') {
        this.changeLoading()
        this.viewType = 'twoweek'
        var maxDay = moment(this.standardDay).set('day', -5).add(1, 'week').format('YYYY-MM-DD')
        var minDay = moment(this.standardDay).set('day', -12).add(-8, 'week').format('YYYY-MM-DD')
        this.clickUrl = url
        var clickUrl = url
        var pages = 1
        var data = { maxDay: maxDay, minDay: minDay, clickUrl: clickUrl, pages: pages, type: 'biweek' }
        this.$store.dispatch('directtalk/getGraphData', data)
      } else if (this.viewType === 'month') {
        this.changeLoading()
        this.viewType = 'month'
        var maxDay = moment(this.standardDay).add('month', 0).endOf('month').format('YYYY-MM-DD')
        var minDay = moment(this.standardDay).add('month', -5).startOf('month').format('YYYY-MM-DD')
        this.clickUrl = url
        var clickUrl = url
        var pages = 1
        var data = { maxDay: maxDay, minDay: minDay, clickUrl: clickUrl, pages: pages, type: 'month' }
        this.$store.dispatch('directtalk/getGraphData', data) 
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container-home {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: calc(100vh - 80px);
  width: calc(100% - 200px);
  flex-wrap: wrap;
  overflow-y: scroll;
}
.container-home::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.header-box {
  width: calc(100% - 80px);
  margin: 10px 40px;
  margin-bottom: 25px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
}
.header-menu {
  display: flex;
  justify-content: center;
  align-items: center;
}
.menu {
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
  align-items: flex-start;
  padding: 16px 0 8px 0;
  width: 100%;
}
.graph-tabs {
  margin-right: 124px;
  ul {
    li {
      font-size: 12px;
    }
  }
}
.graph-tab-item {
  color: #363636;
}
.is-active-tab {
  background: #F0F0F0;
}
.kpi-01 {
  margin-left: 50px;
  height: 200px;
  width: 200px;
}
.preview {
  &.-left {
    margin-left: 8px;
  }
  &.-right {
    margin-right: 8px;
    margin-left: 8px;
  }
}
.card-image-title {
  padding-top: 20px;
  display: inline-flex;
}
.title-content {
  display: inline-flex;
}
.activity {
  margin-left: 50px;
  width: 80vw;
}
.chart {
  margin: auto;
  width: 85vw;
  margin-bottom: 40px;
  position: relative;
}

.graph {
  display: flex;
  justify-content: flex-start;
  padding: 40px;
  padding-top: 10px;
  width: 80vw;
  height: 50vh;
}

.movegraph {
  display: flex;
  justify-content: space-evenly;
  padding-top: 10%;
  width: 50vw;
}

.seeker-table {
  margin: auto;
  margin-bottom: 40px;
  table-layout: fixed;
  width: 90%;
  tr {
    th {
      font-size: 12px;
      vertical-align: middle;
      padding: 8px;
    }
    td {
      vertical-align: middle;
      word-break : break-all;
      padding: 8px;
    } 
  }
}

.default-color {
  color: #707070;
}
.red {
  color: #D81B60;
}
.purple {
  color: #5E35B1;
}
.blue {
  color: #039BE5;
}
.green {
  color: #00897B;
}
.lightgreen {
  color: #7CB342;
}
.yellow {
  color: #FDD835;
}
.orange {
  color: #FB8C00;
}
.brown {
  color: #6D4C41;
}
.red-th {
  color: #D81B60;
  cursor: pointer;
  &:hover {
    background-color: #FCE4EC;
  }
}
.purple-th {
  color: #5E35B1;
  cursor: pointer;
  &:hover {
    background-color: #EDE7F6;
  }
}
.blue-th {
  color: #039BE5;
  cursor: pointer;
  &:hover {
    background-color: #E3F2FD;
  }
}
.green-th {
  color: #00897B;
  cursor: pointer;
  &:hover {
    background-color: #E0F2F1;
  }
}
.lightgreen-th {
  color: #7CB342;
  cursor: pointer;
  &:hover {
    background-color: #F9FBE7;
  }
}
.yellow-th {
  color: #FDD835;
  cursor: pointer;
  &:hover {
    background-color: #FFFDE7;
  }
}
.orange-th {
  color: #FB8C00;
  cursor: pointer;
  &:hover {
    background-color: #FFF3E0;
  }
}
.brown-th {
  color: #6D4C41;
  cursor: pointer;
  &:hover {
    background-color: #EFEBE9;
  }
}
.btnColor {
  &_red {
    background-color: #F8BBD0!important;
  }
  &_purple {
    background-color: #D1C4E9!important;
  }
  &_blue {
    background-color: #BBDEFB!important;
  }
  &_green {
    background-color: #B2DFDB!important;
  }
  &_lightgreen {
    background-color: #DCEDC8!important;
  }
  &_yellow {
    background-color: #FFF9C4!important;
  }
  &_orange {
    background-color: #FFE0B2!important;
  }
  &_brown {
    background-color: #D7CCC8!important;
  }
}
.index-number {
  margin-right: 4px;
}
.url{
  p {
    color: #1155CC;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
  }
}
.sum {
  font-size: 12px;
}
.count {
  font-size: 14px;
}
.bold {
  font-weight: bold;
}
.blank {
  height: 20px;
}
.pagination-wrapper {
  margin: 0 80px 24px auto;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Home/Home.vue